import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../utils/config';
export { sendEmail, doMfa, getMfaToken };
var getEmailCodeQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetEmailCode($token: String!, $client: String!) {\n    mfaEmailCode(mfaToken: $token, clientId: $client)\n  }\n"])));
var performMfaQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query PerformMfa(\n    $mfaToken: String!\n    $oobCode: String!\n    $mfaCode: String!\n    $deviceId: String\n    $client: String!\n  ) {\n    mfaTokens(\n      mfaToken: $mfaToken\n      oobCode: $oobCode\n      mfaCode: $mfaCode\n      deviceId: $deviceId\n      clientId: $client\n    ) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));
var triggerMfaQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query GetMfaToken($client: String!) {\n    mfaToken(clientId: $client)\n  }\n"])));
function sendEmail(_x) {
  return _sendEmail.apply(this, arguments);
}
function _sendEmail() {
  _sendEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('sendEmail', getEmailCodeQuery, {
            token: token,
            client: getClientId()
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.mfaEmailCode);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sendEmail.apply(this, arguments);
}
function doMfa(_x2, _x3, _x4, _x5) {
  return _doMfa.apply(this, arguments);
}
function _doMfa() {
  _doMfa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mfaToken, oobCode, mfaCode, deviceId) {
    var data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return wrapQuery('doMfa', performMfaQuery, {
            mfaToken: mfaToken,
            oobCode: oobCode,
            mfaCode: mfaCode,
            client: getClientId(),
            deviceId: deviceId
          });
        case 2:
          data = _context2.sent;
          return _context2.abrupt("return", data.mfaTokens.tokens);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _doMfa.apply(this, arguments);
}
function getMfaToken(_x6) {
  return _getMfaToken.apply(this, arguments);
}
function _getMfaToken() {
  _getMfaToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(clientId) {
    var data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return wrapQuery('getMfaToken', triggerMfaQuery, {
            client: clientId || getClientId()
          });
        case 2:
          data = _context3.sent;
          return _context3.abrupt("return", data.mfaToken);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getMfaToken.apply(this, arguments);
}